/* eslint-disable jsx-a11y/anchor-is-valid */ /* eslint-disable react/jsx-no-target-blank */ import _define_property from "@swc/helpers/src/_define_property.mjs";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Heading } from "@cinch-labs/design-system";
import Image from "next/image";
import cx from "classnames";
import styles from "./hero-with-rich-text.module.css";
import { Wrapper } from "@cinch-nx/shared-ui";
import renderWithResolver from "../../../rich-text-renderer/rich-text-renderer";
export var HeroWithRichText = function(blok) {
    var title = blok.title, body = blok.body, image = blok.image;
    var hasImageFilename = image === null || image === void 0 ? void 0 : image.filename;
    var contentBodyText = renderWithResolver(body);
    var ref;
    return /*#__PURE__*/ _jsxs(Wrapper, {
        isSlim: true,
        className: {
            inner: cx(hasImageFilename ? styles.root : styles.singleTitleWrapper, _define_property({}, styles.singleTitleWrapper, !hasImageFilename))
        },
        children: [
            hasImageFilename && /*#__PURE__*/ _jsx("div", {
                className: styles.imageWrapper,
                children: /*#__PURE__*/ _jsx(Image, {
                    src: image === null || image === void 0 ? void 0 : image.filename,
                    alt: (ref = image === null || image === void 0 ? void 0 : image.alt) !== null && ref !== void 0 ? ref : undefined,
                    layout: "fill",
                    priority: true,
                    objectFit: "contain"
                })
            }),
            /*#__PURE__*/ _jsxs("div", {
                className: styles.heroContent,
                children: [
                    /*#__PURE__*/ _jsx(Heading, {
                        element: "h1",
                        className: styles.title,
                        children: title
                    }),
                    /*#__PURE__*/ _jsx("div", {
                        className: styles.body,
                        children: contentBodyText
                    })
                ]
            })
        ]
    });
};
